export const TIMEOUT_TO_HIDE_CROUTON_AFTER_TIMER_EXPIRED = 10000;

export const NR_EVENT_TYPE = {
    INCOMING_TIMER: "incoming_timer",
};
